import { PatientRoutePattern } from 'navigation/router/route-switch/route-switch-patient/utils/patient-route-helpers';
import { useLocation, matchPath } from 'react-router-dom';

export function useClinicianPatientMenuInfo() {
  const location2 = useLocation();
  const match = matchPath<{ patientId: string; action: string }>(
    location2.pathname,
    {
      path: `${PatientRoutePattern}/:action*` as const
    }
  );
  const isMenuEnabled = !!match;
  return { isMenuEnabled, match };
}
